///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GtthSharedModule } from '../shared/shared.module';
import { customerPopupRoute, customerRoute } from './customers.route';
import { GtthCustomerComponent } from './customers.component';
import { DeleteCustomerDialogComponent } from './dialogs/delete-customer-dialog/delete-customer-dialog.component';
import { BlockCustomerDialogComponent } from './dialogs/block-customer-dialog/block-customer-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { UsersGridModule } from '../users/users-grid.module';
import { DeleteCustomerDialogWrapperComponent } from './dialogs/delete-customer-dialog/delete-customer-dialog-wrapper.component';
import { CreateCustomerDialogWrapperComponent } from './dialogs/create-or-edit-customer-dialog/create-customer-dialog-wrapper.component';
import { EditCustomerDialogWrapperComponent } from './dialogs/create-or-edit-customer-dialog/edit-customer-dialog-wrapper.component';
import { BlockCustomerDialogWrapperComponent } from './dialogs/block-customer-dialog/block-customer-dialog-wrapper.component';
import { EditCustomerRestrictionsDialogWrapperComponent } from './dialogs/restrictions-dialog/edit-customer-restrictions-dialog-wrapper.component';
import { CustomerRestrictionsDialogComponent } from './dialogs/restrictions-dialog/customer-restrictions-dialog.component';
import { GridDirectivesModule } from '../shared/directives/grid-directives/grid-directives.module';
import { MultipleSelectComponent } from '../shared/sui-lib-customisations/sui-multiple-select/sui-winde-multiple-select.component';
import { ContextSensitiveHelpComponent } from '../shared/context-sensitive-help/ctx-sensitive-help.component';
import {
    SuiLoadingDirective,
    SuiNumberControlComponent,
    SuiSelectControlComponent,
    SuiStringControlComponent,
    SuiSvgIconComponent,
    SuiToggleControlComponent,
    SuiTranslateDirective,
    SuiTranslatePipe
} from '@siklu/sui-lib';

const ENTITY_STATES = [...customerRoute, ...customerPopupRoute];

@NgModule({
    imports: [
        GtthSharedModule,
        RouterModule.forChild(ENTITY_STATES),
        MatDialogModule,
        UsersGridModule,
        GridDirectivesModule,
        MultipleSelectComponent,
        ContextSensitiveHelpComponent,
        SuiSvgIconComponent,
        SuiTranslateDirective,
        SuiTranslatePipe,
        SuiLoadingDirective,
        SuiStringControlComponent,
        SuiToggleControlComponent,
        SuiSelectControlComponent,
        SuiNumberControlComponent
    ],
    declarations: [
        GtthCustomerComponent,
        DeleteCustomerDialogComponent,
        BlockCustomerDialogComponent,
        CreateCustomerDialogWrapperComponent,
        EditCustomerDialogWrapperComponent,
        DeleteCustomerDialogWrapperComponent,
        BlockCustomerDialogWrapperComponent,
        CustomerRestrictionsDialogComponent,
        EditCustomerRestrictionsDialogWrapperComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GtthCustomersModule {}
